/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ExpoInputs */

const en_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expo`)
};

const ar_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إكسبو`)
};

const bn_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expo`)
};

const de_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expo`)
};

const es_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expo`)
};

const fr_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposition`)
};

const pt_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expo`)
};

const zh_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`博览会`)
};

const tr_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuar`)
};

const ru_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспо`)
};

const pl_svchip_expo = /** @type {(inputs: Svchip_ExpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wystawa`)
};

/**
* | output |
* | --- |
* | "Expo" |
*
* @param {Svchip_ExpoInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_expo = /** @type {((inputs?: Svchip_ExpoInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ExpoInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_expo(inputs)
	if (locale === "bn") return bn_svchip_expo(inputs)
	if (locale === "de") return de_svchip_expo(inputs)
	if (locale === "es") return es_svchip_expo(inputs)
	if (locale === "fr") return fr_svchip_expo(inputs)
	if (locale === "pt") return pt_svchip_expo(inputs)
	if (locale === "zh") return zh_svchip_expo(inputs)
	if (locale === "tr") return tr_svchip_expo(inputs)
	if (locale === "ru") return ru_svchip_expo(inputs)
	if (locale === "pl") return pl_svchip_expo(inputs)
	return en_svchip_expo(inputs)
});